/**
 * Warm public landing API caches as early as possible (before route components mount).
 */

import { SITE_SETTINGS_CHANGED_EVENT } from '@constants/siteSettingsSync';
import { SITE_ANNOUNCEMENTS_CHANGED_EVENT } from '@constants/siteAnnouncementsSync';
import { getActiveSemester, getPublicLandingAnnouncements } from '@services/publicLandingApi';
import { siteSettingsApi } from '@services/siteSettingsApi';
import { writePublicSiteAnnouncementsCache } from '@utils/publicSiteAnnouncementsCache';
import { writePublicSiteSettingsCache } from '@utils/publicSiteSettingsCache';

let started = false;

/** Warm public landing API caches as early as possible (before route components mount). */
export function prefetchLandingPublicData(): void {
  if (started) return;
  started = true;

  void getActiveSemester();
  void getPublicLandingAnnouncements().then((list) => {
    writePublicSiteAnnouncementsCache(list ?? []);
    window.dispatchEvent(new Event(SITE_ANNOUNCEMENTS_CHANGED_EVENT));
  });
  void siteSettingsApi.get().then((res) => {
    const settings = res.data?.settings;
    if (settings) {
      writePublicSiteSettingsCache(settings);
      window.dispatchEvent(new Event(SITE_SETTINGS_CHANGED_EVENT));
    }
  });
}
